import { Controller } from "@hotwired/stimulus"
import hljs from "highlight.js/lib/core"
import javascript from "highlight.js/lib/languages/javascript"
import typescript from "highlight.js/lib/languages/typescript"
import bash from "highlight.js/lib/languages/bash"
import "highlight.js/styles/github-dark.min.css"

hljs.registerLanguage("javascript", javascript)
hljs.registerLanguage("typescript", typescript)
hljs.registerLanguage("bash", bash)

export default class extends Controller {
  static targets = ["block"]

  connect() {
    this.blockTargets.forEach((block) => {
      hljs.highlightElement(block)
    })
  }
}
